var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mt-0 pa-1",attrs:{"fluid":"","grid-list-lg":""}},[(_vm.$can('Home'))?[(_vm.hasGroup('negotiator'))?_c('dashboard-negotiator'):_c('dashboard-admin')]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }